export default __webpack_public_path__ + "static/media/Arimo-VariableFont_wght.911df5c2.ttf";